export default "__VITE_ASSET__C0xxcQF___"